<template>
    <div>
        <PageHeader :title="title" />

        <div class="row">
            <div class="col-lg-6 d-flex flex-wrap">
                <div class="card w-100">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <h3 class="card-title mb-2">Liste des questions</h3>
                                <p class="text-muted font-size-12 mb-4 pb-2">
                                    Liste des question par version
                                </p>
                            </div>

                            <div class="col-4">
                                <dropdown placeholder="Version" v-model="selectedVersion" :options="versionsList" dark />
                            </div>
                            <div class="col-auto pl-0">
                                <b-button variant="outline-dark" pill @click="addNewVersion">+ Nouvelle version</b-button>
                            </div>
                        </div>

                        <div v-for="(question, index) in questions" :key="index" class="question">
                            <!-- <hr v-if="index" class="border-secondary" /> -->
                            <Loader :loading="question.loading" />

                            <b-button v-if="question.id" class="delete-btn" size="sm" variant="danger" pill @click="deleteQuestion(question)">Supprimer</b-button>

                            <div class="form-group">
                                <label class="d-block text-muted font-size-12">Type</label>
                                <b-form-radio-group
                                    class="w-100 bg-soft-primary"
                                    button-variant="outline-primary"
                                    v-model="question.type"
                                    :options="questionTypes"
                                    value-field="id"
                                    text-field="nom"
                                    buttons
                                    @change="onQuestionTypeChange(question)"
                                />
                                <!-- <multiselect v-model="question.type" placeholder="" label="nom" track-by="id" :options="questionTypes"></multiselect> -->
                            </div>

                            <template v-if="question.type && question.type != 'divider'">
                                <div class="form-group">
                                    <label class="text-primary font-size-12"
                                        ><span class="font-weight-semibold">Question {{ question.id }}</span></label
                                    >
                                    <b-form-input v-model="question.text" @blur="onQuestionChange('text', question)" />
                                </div>

                                <div class="form-group" v-if="['radio', 'checkbox', 'dropdown'].includes(question.type)">
                                    <label class="text-muted font-size-12">Options</label>
                                    <TagsInput
                                        v-model.lazy="question.options"
                                        placeholder=""
                                        @tag-removed="onQuestionChange('options', question)"
                                        @keyup="e => e.keyCode == 13 && onQuestionChange('options', question)"
                                    />
                                </div>

                                <div class="form-group">
                                    <div class="row">
                                        <div class="col">
                                            <label class="text-muted font-size-12">Afficher avec condition</label>
                                            <b-form-checkbox v-model="question.hasCondition" size="lg" switch @change="onQuestionChange('condition', question)" />
                                        </div>
                                        <div class="col">
                                            <template v-if="question.hasCondition">
                                                <label class="text-muted font-size-12">Afficher si la valeur de</label>
                                                <dropdown
                                                    v-model="question.conditionFirstPart"
                                                    :options="questionsList"
                                                    @input="() => question.conditionSecondPart && onQuestionChange('condition', question)"
                                                />
                                            </template>
                                        </div>
                                        <div class="col">
                                            <div v-if="question.hasCondition" :style="!question.conditionFirstPart && 'opacity: .5; pointer-events: none'">
                                                <label class="text-muted font-size-12">Egale</label>
                                                <b-form-input v-model="question.conditionSecondPart" @blur="onQuestionChange('condition', question)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div class="d-flex justify-content-end mt-3">
                            <q-button class="pb-0" variant="link" @click="() => this.questions.push({ loading: false })">+ Autre question</q-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col d-flex">
                <div class="card w-100">
                    <div class="card-body">
                        <h3 class="card-title mb-2">Apercu du questionnaire</h3>
                        <p class="text-muted font-size-12 mb-4 pb-2">
                            Vous pouvez ajouter des question à partire du formulaire à gauche
                        </p>

                        <div class="mb-3" v-for="question in questions" :key="question.id">
                            <template v-if="question.type && condition(question)">
                                <p class="text-primary" v-if="question.text">{{ question.text }}</p>
                                <template v-if="['radio', 'checkbox'].includes(question.type) && question.options">
                                    <component :is="`b-form-${question.type}-group`" v-model="responses[question.id]" stacked :options="question.options.map(item => item.value)"></component>
                                </template>
                                <dropdown
                                    v-if="question.type == 'dropdown' && question.options"
                                    v-model="responses[question.id]"
                                    label=""
                                    placeholder=""
                                    :options="question.options.map(item => item.value)"
                                />
                                <b-input v-if="question.type == 'text'" v-model="responses[question.id]" />
                                <hr v-if="question.type == 'divider'" class="my-5" />
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TagsInput from "@voerro/vue-tagsinput";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import "@voerro/vue-tagsinput/dist/style.css";
    import Loader from "@/components/ui/loader";

    export default {
        page: {
            title: "Gestion des questions",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
            TagsInput,
            Loader
        },
        data: () => ({
            title: "Gestion des questions",
            questionTypes: [
                { id: "text", nom: "Texte" },
                { id: "radio", nom: "Radios" },
                { id: "checkbox", nom: "Checkboxes" },
                { id: "dropdown", nom: "Liste" },
                { id: "divider", nom: "Séparateur" }
            ],
            questionsList: [],
            questions: [{ loading: false }],
            responses: {},
            versionsList: [],
            selectedVersion: null
        }),
        watch: {
            selectedVersion() {
                this.loadQuestions();
            }
        },
        methods: {
            async loadQuestions() {
                const resp = await this.$axios.get(`/questions/builder/${this.selectedVersion?.id}`);
                this.questionsList = resp.questionsList;
                this.questions = resp.questions;
            },
            async onQuestionTypeChange(question) {
                if (question.id) {
                    this.onQuestionChange("type", question);
                    return;
                }
                try {
                    question.loading = true;
                    const resp = await this.$axios.post("/questions", {
                        version: this.selectedVersion.id,
                        question
                    });

                    this.questionsList = resp.questionsList;
                    this.questions = resp.questions;
                } finally {
                    question.loading = false;
                }
            },
            async onQuestionChange(key, question) {
                try {
                    question.loading = true;
                    const questionClone = { ...question };

                    if (key == "options") questionClone.options = JSON.stringify(questionClone.options.map(item => item.value));

                    if (key == "condition") questionClone.condition = `${question.conditionFirstPart.id} == ${question.conditionSecondPart}`;

                    const resp = await this.$axios.put("/questions", {
                        version: this.selectedVersion.id,
                        question: {
                            id: question.id,
                            idAnnee: question.idAnnee,
                            [key]: questionClone[key],
                            ...(question.type == "devider" && { text: null, options: null, condition: null }),
                            ...(question.type == "text" && { options: null }),
                            ...(!question.hasCondition && { condition: null })
                        }
                    });

                    this.questions = resp.questions;
                } finally {
                    question.loading = false;
                }
            },
            async deleteQuestion(question) {
                try {
                    question.loading = true;
                    const deleted = await this.$axios.delete(`/questions/${question.id}`);
                    if (!deleted) return;
                    this.questions = this.questions.filter(item => item.id != question.id);
                } finally {
                    question.loading = false;
                }
            },
            condition(question) {
                if (!question.conditionFirstPart || !question.conditionSecondPart) return true;

                const type = question.type;
                if (type == "checkbox") return this.responses[question.conditionFirstPart.id]?.[0] == question.conditionSecondPart;
                return this.responses[question.conditionFirstPart.id] == question.conditionSecondPart;
            },
            addNewVersion() {
                const id = Math.max(...this.versionsList.map(item => item.id)) + 1;
                this.versionsList = [{ id, nom: `Version ${id}` }, ...this.versionsList];
                this.selectedVersion = this.versionsList[0];
            }
        },
        mounted() {
            this.loadQuestions();

            this.$axios.get("/questions/versions").then(versions => {
                this.versionsList = versions.length ? versions : [{ id: 1, nom: "Version 1" }];
                this.selectedVersion = this.versionsList[0];
            });
        }
    };
</script>

<style lang="scss">
    .question {
        position: relative;
        padding: 25px 25px 15px;
        margin-bottom: 30px;
        border-radius: 10px;
        background-color: $light;
        border: 1px solid darken($light, 5%);

        .delete-btn {
            position: absolute;
            top: -10px;
            right: 20px;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s;
        }

        &:hover {
            .delete-btn {
                opacity: 1;
                visibility: visible;
            }
        }
    }

    #sidebar-right___title__ {
        font-size: 18px;
    }

    .custom-radio,
    .custom-checkbox {
        margin-bottom: 4px;
    }

    .tags-input {
        outline: none !important;
        box-shadow: none !important;
        border-color: $input-border-color !important;
        border-radius: $input-border-radius;
        padding: $input-padding-y $input-padding-x;

        &.active {
            border-color: $input-focus-border-color !important;
        }

        &-badge {
            background-color: darken($light, 2%);
            //color: #fff;
            font-size: 85%;
            font-weight: normal;
            padding: 6px 16px 6px 10px;
            margin-bottom: 3px;
            margin-top: 3px;
        }

        &-remove {
            top: 6px;
            right: 6px;

            &::before,
            &::after {
                background: $dark;
            }
        }
    }
</style>
